export default __webpack_public_path__ + "static/media/flask.3a89d3fc.png";